<template>
  <div class="col-span-12 mb-5 mt-12">
    <!-- TITLE -->
    <h3
      v-if="field?.display"
      class="w-full font-semibold typo-h6"
    >
      {{ shouldTranslate ? $t(`forms.${field.handle}`) : field.display }}
    </h3>

    <!-- DESCRIPTION -->
    <p v-if="field.instructions" class="mt-2 max-w-text">
      {{ field.instructions }}
    </p>
  </div>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
defineProps({
  field: {
    type: Object,
    default: null,
  },
})

const shouldTranslate = inject('shouldTranslate', false)
</script>
